

















































































import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import Categories from '@/components/organisms/CategoriesV2/Categories.vue';
import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';

import eventBus from '@/utils/eventBus';

import InviteMerchantSignupModalsModel from '@/views/Models/InviteMerchantSignupModalsModel.vue';

export interface IBusinessCategory {
  id: string;
  label: string;
  otherValue?: string;
}

export interface IBusinessInfo {
  businessName: string;
  businessCategory: IBusinessCategory;
}

@Component({
  components: {
    Typography,
    CloseModalIcon,
    FilledButton,
    TextField,
    Categories,
    InputWrapper,
    ValidationObserver,
    ValidationProvider
  }
})
export default class EditBusinessInfo extends Mixins(
  Vue,
  InviteMerchantSignupModalsModel
) {
  @Prop() readonly initialData!: IBusinessInfo;
  @Prop() readonly code!: string;
  @Prop() readonly onSuccess?: (newData?: IBusinessInfo) => void;

  form = {
    businessName: this.initialData.businessName || '',
    businessCategory: {
      id: this.initialData.businessCategory.id || '',
      label: this.initialData.businessCategory.label || '',
      otherValue: ''
    }
  };

  categories: any[] = this.filledCategories;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get hasChanges() {
    return (
      this.form.businessName !== this.initialData.businessName ||
      this.form.businessCategory.id !== this.initialData.businessCategory.id
    );
  }

  get filledCategories() {
    return this.$store.getters['businessOnboarding/getCategories'] || [];
  }

  get otherCategory() {
    const category = this.categories.find(categ =>
      categ.label.includes('Other')
    );

    if (!category) return {};

    return category;
  }

  get hasOtherError() {
    return (
      this.otherCategory &&
      this.otherCategory.value === this.form.businessCategory.id &&
      !this.form.businessCategory.otherValue
    );
  }

  toggleCategory(categoryItem: { value: string; label: string }) {
    const category = this.categories.find(
      category => category.value === categoryItem.value
    );
    if (!category) return;

    this.form.businessCategory.id = categoryItem.value;
    this.form.businessCategory.label = categoryItem.label;
  }

  handleChangeOtherInput(value: string) {
    this.form.businessCategory.otherValue = value;
  }

  handleCloseCategory() {
    this.form.businessCategory = {
      id: '',
      otherValue: '',
      label: ''
    };
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) return;

    if (!this.hasChanges) {
      this.onClose();
      return;
    }

    this.submitLoading = true;

    const response = await this.service.updateBusinessInfo(this.code, {
      name: this.form.businessName,
      categoryId: this.form.businessCategory.id,
      otherCategory: this.form.businessCategory.otherValue
    });

    this.submitLoading = false;

    if (response.status === 200) {
      if (this.onSuccess) this.onSuccess(this.form);
    }

    this.onClose();
  }
}
